import React, { useEffect } from "react";
import {
  AppBar,
  Button,
  CircularProgress,
  CssBaseline,
  Fab,
  Hidden,
  IconButton,
  Toolbar,
} from "@material-ui/core";
import { useStylesBA, useStylesCAB } from "../../../../../St/comps/UseStyle";
import toast, { Toaster } from "react-hot-toast";
import CloseIcon from "@material-ui/icons/Close";
import SearchIcon from "@material-ui/icons/Search";
import AddBoxIcon from "@material-ui/icons/AddBox";
import SaveIcon from "@material-ui/icons/Save";
import PrintIcon from "@material-ui/icons/Print";
import { Fragment } from "react";
import { useState } from "react";
import { cellS, headerS, stElemnt } from "../../../../../St/comps/cStyle";
import moment from "moment";
import { useHistory } from "react-router-dom";
import ReceiptSearchModal from "../components/Receipt-search-modal";
import { IRReFormatingData } from "../../../../../services/IReceipt-service";
import {
  ExchangeValidateSchema,
  PrepareData,
  ReFormatingData,
} from "../../../../../services/InernalVoucher-service";
import axios from "axios";
import { uri } from "../../../../../help/Api";
import { insh, sto } from "../../../../../Context/InshData";
import { useTranslation } from "react-i18next";
import { paymentType } from "../components/ReceiptVoucher-typeFilter";
import { Delete, Scanner } from "@material-ui/icons";
import PagenationButtons from "../../../../../components/controls/PagenationButons";
import SearchReaceiptCon from "../components/SearchRecipts/SearchReaceiptCon";
import ButtonsSearch from "../components/ButtonsSearch";

var columnsInv = [
  { title: "الرقم", field: "id", headerStyle: headerS, cellStyle: cellS },
  { title: "التاريخ", field: "date", headerStyle: headerS, cellStyle: cellS },
  { title: "المبلغ", field: "val", headerStyle: headerS, cellStyle: cellS },
  {
    title: "مندوب المبيعات",
    field: "empName",
    headerStyle: headerS,
    cellStyle: cellS,
  },
  {
    title: "المرجع",
    field: "check_no",
    headerStyle: headerS,
    cellStyle: cellS,
  },
  {
    title: "الحساب",
    field: "custName",
    headerStyle: headerS,
    cellStyle: cellS,
  },
  { title: "البيان", field: "notes", headerStyle: headerS, cellStyle: cellS },
];

export default function IExchangeVoucherAppBar(props) {
  const {
    submit,
    isDialog,
    onClose,
    remove,
    prmis,
    update,
    defaultV,
    submitting,
    onShow,
    object,
    URL,
    formType,
    getRow,
    AutoOptions,
    branch,
    branchT,
    setBranchT,
    AutoOptionsB,
    setOptionsStocks
  } = props;
  let his = useHistory();
  const [openSearchMdl, setOpenSearchMdl] = useState(false);
  const [openButtonsSearch, setOpenButtonsSearch] = useState(false);
  const [procIdSearch, setProcIdSearch] = useState(0);

  const clasBA = useStylesBA();
  const clasCAB = useStylesCAB();
  const styBtn = {
    dis: { color: "#3b773d", background: "#4fa152" },
    undis: { color: "#fff" },
  };

  const { t } = useTranslation(["forms"]);

  const newEReceipt = () => {
    onShow(defaultV, "new");
    setOpenButtonsSearch(false);
    setProcIdSearch(0);
    toast("إضافة سند جديد");
  };

  const addChangds = () => {
    object.date =
      moment(object.date).format("YYYY-MM-DD") +
      moment(new Date()).format(" h:mm A");
    object.branch = formType === "edit" && !props.isDialogData ? branchT : props.isDialogData ? props.invData.branch : branch.id == -1 ? sto.branchi : branch.id;
  }
  const onSubmitHandle = (isPrint, isLarge = false) => {
    addChangds();
    let pData = PrepareData(object);
    let nData = {
      ...pData,
    };
    const data = {
      sandSD: nData,
      stor: { invsType: 1 },
    };

    ExchangeValidateSchema.validate(nData, { abortEarly: false })
      .then(async () => {
        if (formType == "edit") {
          if (isPrint) handlePrint(nData, object, isLarge);
          else await update(data).then((res) => {
            if (res.data?.id == null) {
              toast.error(res.data);
              if (props.isDialogData === true) {
                props.onClose();
              }
            } else {
              if (props.isDialogData === true) {
                props.onClose();
              }
            }

          });
        } else {
          await submit(data).then((res) => {
            if (isPrint) handlePrint(res.data, object, isLarge);
            // toast.success('تم إضافة السند')
          });
        }
      })
      .catch((err) => {
        toast.error(err.errors[0]);
        console.log(err);
      });
  };

  const handlePrint = (rptdata, oldObject, isLarge) => {
    console.log("the data is", oldObject);
    console.log("the data is", rptdata);

    const info = {
      temp: 2,
      columns: columnsInv,
      data: rptdata,

      custN: "دفعة لحساب",
      from: "الصرف",
      title: "سند صرف - داخلي",
      subTitle: "Internal Exchange Voucher",
      label: "صرفنا الى السيد",
      auto: {
        empName: oldObject.emp.name,
        center: oldObject.center.name,
        custName: oldObject.acc_code.name,
        stockName:
          rptdata?.type == 1 ? oldObject.stock?.name : oldObject.bank?.name,
        type: t(paymentType[rptdata?.type - 1].name),
      },
      //   fDate:dateFrom,tDate:dateTo,
      Date: moment(rptdata.date).format("YYYY-MM-DD"),
      ElmntShow: true,
    };
    console.log("the data is", info);
    localStorage.setItem("iInfos", JSON.stringify(info));
    if (isLarge) his.push({ pathname: "/voucher2" });
    else his.push({ pathname: "/SC" });
    window.location.reload(false);
  };

  const onRowDialog = async () => {
    if (props.isDialogData == true) {
      let data = props.invData;
      const data2 = {
        ...data,
        acc_name: data.acc_name,
        custName: data.acc_name,
        emp_id: data.sales_emp,
      }
      let FormatedData = ReFormatingData(data2, AutoOptions);
      console.log("the data is after ", FormatedData);
      let end_dept1 = "0.0";
      await axios
        .get(
          uri +
          `AccountReports/rptABalanceSum?branch=${data.branch}
        &&costCenter=${-1}
        &&acc_code=${FormatedData.acc_code.code.toString()}`
        )
        .then((res) => {
          end_dept1 = res.data.end_Dept - res.data.end_Credit;
        })
        .catch((res) => { });
      setOpenSearchMdl(false);
      onShow({ ...FormatedData, end_Dept: end_dept1 }, "edit");
    }
  };

  useEffect(() => {
    // console.log("the rowssss is", props.invData)

    onRowDialog();
  }, []);
  const onClickButton = async (procId, type) => {
    const tb = {
      wait: true,
      ButtonSearchSand: true,
      stor: sto,
      parms: {
        tname: type,
        branch: sto.branchi,
        iprocid: procId,
        iempid: sto.idi,
        type: "3",

      },
    };
    axios
      .post(uri + "GetD", tb)
      .then((res) => {
        setProcIdSearch(res.data?.Sand_data?.id);
        if (res.data?.Sand_data.id > 0) {
          onRowClick({
            ...res.data.Sand_data,
            acc_name: res?.data?.Sand_data?.acc_name,
            custName: res.data.Sand_data?.acc_name,
            emp_id: res.data.Sand_data?.sales_emp,
          });
        }
      })
      .catch((error) => {
      });
  };
  const onRowClick = (row) => {
    setBranchT(row?.branch);
    const tb = {
      Stocks: true, // Error // out
      parms: {
        branch: row?.branch,
        ibranchid: row?.branch,
        iempid: sto.empi,
        withOmlat: true,
      },
    };

    axios
      .post(uri + "Res", tb)
      .then((res) => {
        setOptionsStocks(res.data?.Stocks);
        const optinsNew = {
          ...AutoOptions,
          Stocks: res.data?.Stocks,
        };
        onRowClickAfter({ ...row }, optinsNew);
      })
      .catch((error) => {
      });
  };

  const onRowClickAfter = async (row, optinsNew) => {
    setBranchT(row?.branch);
    let FormatedData = ReFormatingData(row, optinsNew);
    console.log("the data is after ", FormatedData);
    let end_dept1 = "0.0";
    await axios
      .get(
        uri +
        `AccountReports/rptABalanceSum?branch=${row.branch}
        &&costCenter=${-1}
        &&acc_code=${FormatedData.acc_code.code.toString()}`
      )
      .then((res) => {
        end_dept1 = res.data.end_Dept - res.data.end_Credit;
      })
      .catch((res) => { });
    setOpenSearchMdl(false);
    onShow({ ...FormatedData, end_Dept: end_dept1 }, "edit");
  };

  const onGetRow = (type) => async (e) => {
    await getRow({
      branch: sto.branchi,
      id: object.id,
      type: type
    }).then(res => {
      if (res != null) {
        onRowClick(res?.data);
      }
      console.log("the resposent is ", res)
    });

  }

  const [loading, setLoading] = useState(insh.LoadAndSucc);

  const [success, setSuccess] = useState(insh.LoadAndSucc);
  const [confirmDialog, setConfirmDialog] = useState({ isOpen: false });

  const ButtonLoading = (prop) => {
    setLoading({ ...loading, [prop]: true });
  };
  const timer = React.useRef();

  const ButtonSuccess = (prop, state) => {
    timer.current = window.setTimeout(() => {
      setLoading({ ...loading, [prop]: false });
      setSuccess({ ...success, [prop]: true });
      if (
        prop == "delete"
      ) {
        if (state) newObject();
        // reopen();
      }
      timer.current = window.setTimeout(() => {
        setSuccess({ ...success, [prop]: false });
      }, 100);
    }, 1000);
  };
  const newObject = () => {
    setOpenButtonsSearch(false);
    setProcIdSearch(0);
    onShow(defaultV, "new");
  };
  const onDeleteHandle = async (e) => {

    await e.preventDefault();
    setConfirmDialog({ ...confirmDialog, isOpen: false });
    ButtonLoading("delete");

    await axios.delete(uri + `SandSD?id=${object.id}&&branch=${object.branch}`).then(res => {

      if (parseFloat(res.data) > 0) {
        toast.success("لقد تم حذف السند بنجاح");

        if (props.isDialogData === true) {
          props.onClose();
        } else { ButtonSuccess("delete", true); }

      } else {
        toast.error(res.data);
        if (props.isDialogData === true) {
          { props.onClose(); }
        } else { ButtonSuccess("delete", true); }

      }


    }).catch(err => {
      console.log("eror", err)
      ButtonSuccess("delete", false);
      toast.error("not delete ")
    })
  };

  const backHome = () => {
    if (isDialog) onClose();
    else {
      his.push({ pathname: "/" });
      window.location.reload(false);
    }
  };
  const [transition, setTransition] = React.useState(undefined);
  const [isInternal, setIsInternal] = useState(true);

  let type = 1;
  let tname = "3";
  const handCloseDw = () => {

    setOpenSearchMdl(false);
  };

  return (
    <React.Fragment>
      <Toaster />
      <CssBaseline />
      <AppBar
        position="fixed"
        className={clasBA.appBarBASal}
        style={{ backgroundColor: "#808080" }}
      >
        <Toolbar className={clasBA.ToolbarBA} variant="dense">
          {props.isDialogData ?
            (
              <>
                <Hidden smUp={["sm"]}>
                  <IconButton
                    edge="start"
                    color="inherit"
                    aria-label="backH"
                    onClick={props.onClose}
                  >
                    <CloseIcon />
                  </IconButton>

                </Hidden>

                <Hidden only={["xs"]}>
                  <Button
                    style={styBtn.undis}
                    onClick={props.onClose}
                    startIcon={<CloseIcon />}
                  >
                    {t("exit")}
                  </Button>

                </Hidden></>
            ) :
            (
              <>
                <Hidden smUp={["sm"]}>
                  <IconButton
                    edge="start"
                    color="inherit"
                    aria-label="backH"
                    onClick={backHome}
                  >
                    <CloseIcon />
                  </IconButton>
                  <IconButton
                    edge="start"
                    color="inherit"
                    aria-label="searsh"
                    disabled={prmis?.Se}
                    onClick={() => setOpenSearchMdl(true)}
                  >
                    <SearchIcon />
                  </IconButton>
                  <IconButton
                    edge="start"
                    color="inherit"
                    aria-label="handNew"
                    onClick={newEReceipt}
                  >
                    <AddBoxIcon />
                  </IconButton>
                </Hidden>

                <Hidden only={["xs"]}>
                  <Button
                    style={styBtn.undis}
                    onClick={backHome}
                    startIcon={<CloseIcon />}
                  >
                    {t("exit")}
                  </Button>
                  <Button
                    style={styBtn.undis}
                    onClick={() => setOpenSearchMdl(true)}
                    disabled={prmis?.Se}
                    startIcon={<SearchIcon />}
                  >
                    {t("search")}
                  </Button>
                  <Button
                    style={styBtn.undis}
                    onClick={newEReceipt}
                    startIcon={<AddBoxIcon />}
                  >
                    {t("new")}
                  </Button>
                </Hidden></>
            )}

          {!props.isDialogData && (
            <Hidden only={["xs"]}>
              <ButtonsSearch
                {...{
                  onClickButton, openButtonsSearch, procIdSearch, setOpenButtonsSearch
                }}
              />
            </Hidden>
          )}

          <div className={clasBA.growBA} />

          <Hidden smUp={["sm"]}>
            {formType == "edit" && (
              <div className={clasCAB.wrapperCAB}>
                <Fab
                  size="medium"
                  color="primary"
                  // disabled
                  style={{
                    ...stElemnt.all.iconBtn,
                    backgroundColor: "#808080",
                  }}
                  disabled={submitting || prmis?.De}
                  className={clasCAB.buttonSuccessCAB}
                  onClick={onDeleteHandle}
                >
                  <Delete />
                </Fab>

                {submitting && (
                  <CircularProgress
                    size={56}
                    className={clasCAB.fabProgressCAB}
                  />
                )}
              </div>
            )}
            <div className={clasCAB.wrapperCAB}>
              <Fab
                size="medium"
                color="primary"
                style={{ ...stElemnt.all.iconBtn, backgroundColor: "#808080" }}
                className={clasCAB.buttonSuccessCAB}
                disabled={
                  submitting ||
                  (formType == "new" ? prmis?.Sa || prmis?.Pr : prmis?.Pr)
                }
                onClick={() => {
                  onSubmitHandle(true);
                }}
              >
                <Scanner />
              </Fab>
              {submitting && (
                <CircularProgress
                  size={56}
                  className={clasCAB.fabProgressCAB}
                />
              )}
            </div>
            <div className={clasCAB.wrapperCAB}>
              <Fab
                size="medium"
                color="primary"
                style={{ ...stElemnt.all.iconBtn, backgroundColor: "#808080" }}
                className={clasCAB.buttonSuccessCAB}
                disabled={
                  submitting ||
                  (formType == "new" ? prmis?.Sa || prmis?.Pr : prmis?.Pr)
                }
                onClick={() => {
                  onSubmitHandle(true, true);
                }}
              >
                <PrintIcon />
              </Fab>
              {submitting && (
                <CircularProgress
                  size={56}
                  className={clasCAB.fabProgressCAB}
                />
              )}
            </div>

            <div className={clasCAB.wrapperCAB}>
              <Fab
                size="medium"
                color="primary"
                style={{ ...stElemnt.all.iconBtn, backgroundColor: "#808080" }}
                className={clasCAB.buttonSuccessCAB}
                disabled={
                  submitting || (formType == "new" ? prmis?.Sa : prmis?.Up)
                }
                onClick={() => onSubmitHandle(false)}
              >
                {" "}
                <SaveIcon />
              </Fab>

              {submitting && (
                <CircularProgress
                  size={56}
                  className={clasCAB.fabProgressCAB}
                />
              )}
            </div>
          </Hidden>

          <Hidden only={["xs"]}>
            <Fragment>
              {formType == "edit" && (
                <>
                  <div className={clasCAB.wrapperCAB}>
                    <PagenationButtons
                      variant="contained"
                      color="#fff"
                      size="large"
                      className={clasCAB.buttonSuccessCAB}
                      startIcon={<Delete />}
                      style={{
                        ...stElemnt.all.iconBtn,
                        backgroundColor: "#808080",
                      }}
                      disabled={submitting}
                      onClick={onGetRow}

                    />

                    {submitting && (
                      <CircularProgress
                        size={24}
                        className={clasCAB.buttonProgressCAB}
                      />
                    )}
                  </div>
                  <div className={clasCAB.wrapperCAB}>
                    <Button
                      variant="contained"
                      color="primary"
                      size="large"
                      className={clasCAB.buttonSuccessCAB}
                      style={{
                        ...stElemnt.all.iconBtn,
                        backgroundColor: "#808080",
                      }}
                      disabled={submitting || prmis.De}
                      onClick={onDeleteHandle}
                    >
                      {t("delete")}
                    </Button>

                    {submitting && (
                      <CircularProgress
                        size={24}
                        className={clasCAB.buttonProgressCAB}
                      />
                    )}
                  </div>
                </>
              )}
              <div className={clasCAB.wrapperCAB}>
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  className={clasCAB.buttonSuccessCAB}
                  startIcon={<Scanner />}
                  style={{
                    ...stElemnt.all.iconBtn,
                    backgroundColor: "#808080",
                  }}
                  disabled={
                    submitting ||
                    (formType == "new" ? prmis?.Sa || prmis?.Pr : prmis?.Pr)
                  }
                  onClick={() => onSubmitHandle(true)}
                // onClick={() => or.postput == 'toPost' ? toPrint('print','e',1) : toPosh(sdata)}
                >
                  {" "}
                  {t("cashier-view")}
                </Button>

                {submitting && (
                  <CircularProgress
                    size={24}
                    className={clasCAB.buttonProgressCAB}
                  />
                )}
              </div>
              <div className={clasCAB.wrapperCAB}>
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  className={clasCAB.buttonSuccessCAB}
                  startIcon={<PrintIcon />}
                  style={{
                    ...stElemnt.all.iconBtn,
                    backgroundColor: "#808080",
                  }}
                  disabled={
                    submitting ||
                    (formType == "new" ? prmis?.Sa || prmis?.Pr : prmis?.Pr)
                  }
                  onClick={() => onSubmitHandle(true, true)}
                // onClick={() => or.postput == 'toPost' ? toPrint('print','e',1) : toPosh(sdata)}
                >
                  {" "}
                  {formType == "edit" ? t("print") : t("save-print")}
                </Button>
                {submitting && (
                  <CircularProgress
                    size={24}
                    className={clasCAB.buttonProgressCAB}
                  />
                )}
              </div>
              <div className={clasCAB.wrapperCAB}>
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  style={{
                    ...stElemnt.all.iconBtn,
                    backgroundColor: "#808080",
                  }}
                  className={clasCAB.buttonSuccessCAB}
                  disabled={
                    submitting || (formType == "new" ? prmis?.Sa : prmis?.Up)
                  }
                  onClick={() => onSubmitHandle(false)}
                  startIcon={<SaveIcon />}
                >
                  {formType == "edit" ? t("save-update") : t("save")}
                </Button>
                {submitting && (
                  <CircularProgress
                    size={24}
                    className={clasCAB.buttonProgressCAB}
                  />
                )}
              </div>
            </Fragment>
          </Hidden>
        </Toolbar>
      </AppBar>
      {/* <ReceiptSearchModal
        URL={URL}
        isInternal={true}
        open={openSearchMdl}
        onClose={() => {
          setOpenSearchMdl(false);
        }}
        onRowClick={onRowClick}
      /> */}
      <SearchReaceiptCon
        {...{
          openSearchMdl, handCloseDw,
          onRowClick, URL, type, tname, AutoOptions, transition, isInternal,
          AutoOptionsB,
        }}
      />
    </React.Fragment>
  );
}
